var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '../Box';
import styled, { withTheme } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { applyVariations, getPaletteColor, deprecatedColorValue, colorScheme } from '../utils';
const arrowShadow = (props) => {
    return props.top
        ? {
            'box-shadow': '-9.66px 9.66px 8px 0 rgba(0,0,0,0.04), -4px 4px 4px 0 rgba(0,0,0,0.08)',
        }
        : {
            'box-shadow': '-1.41px 1.41px 1px 0 rgba(0,0,0,0.01), -3.66px 3.66px 8px 0 rgba(0,0,0,0.04)',
        };
};
const arrowAlign = (props) => {
    return props.left
        ? { left: '16px', 'margin-left': props.top ? 0 : '15px' }
        : props.center
            ? { left: '50%', 'margin-left': props.top ? '-7px' : '7px' }
            : { right: '16px', 'margin-right': props.top ? '5px' : '-10px' };
};
const arrowPosition = (props) => {
    return props.top
        ? {
            'transform-origin': '0 0',
            transform: 'rotate(-45deg)',
            bottom: '-10px',
        }
        : {
            'transform-origin': '0 0',
            transform: 'rotate(-225deg)',
            top: '0',
        };
};
const arrow = (props) => {
    return props.top
        ? {
            'transform-origin': '0 0',
            transform: 'rotate(-45deg)',
        }
        : {
            'transform-origin': '0 0',
            transform: 'rotate(-225deg)',
        };
};
const tooltipPosition = (props) => {
    return props.top ? { bottom: '-8px' } : { top: 0 };
};
const tooltipAlign = (props) => {
    return props.right
        ? { right: 0 }
        : props.center
            ? { left: '50%', width: 'auto', transform: 'translateX(-50%)' }
            : null;
};
const TooltipContent = styled(Box) `
  display: inline;
  font-size: ${({ theme }) => theme.fontSizes[0]}px;
  position: absolute;
  box-sizing: border-box;
  background: ${(props) => getPaletteColor(props.bg || props.color, 'base')(props)};
  text-align: center;

  ${tooltipPosition} ${tooltipAlign} &::after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent
      ${(props) => getPaletteColor(props.bg || props.color, 'base')(props)}
      ${(props) => getPaletteColor(props.bg || props.color, 'base')(props)};

    ${arrow} ${arrowPosition} ${arrowAlign} ${arrowShadow};
    ${(props) => {
    const colorScheme = themeGet(`colorSchemes.${props.colorScheme}`)(props);
    return colorScheme
        ? `
        color: ${colorScheme.background};
        border-color: ${colorScheme.background};
      `
        : '';
}}
  }

  ${colorScheme}

  ${applyVariations('Tooltip')}
`;
const propTypes = {
    children: PropTypes.any.isRequired,
    bg: deprecatedColorValue(),
    color: deprecatedColorValue(),
    bottom: PropTypes.bool,
    top: PropTypes.bool,
    center: PropTypes.bool,
    left: PropTypes.bool,
    right: PropTypes.bool,
    zIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
const defaultProps = {
    borderRadius: 'md',
    position: 'bottom',
    color: 'background.lightest',
    zIndex: 'auto',
};
const Tooltip = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement("div", { style: { position: 'relative', zIndex: props.zIndex } },
        React.createElement(TooltipContent, Object.assign({ p: 2, mb: 3, mt: 2, boxShadowSize: 'md' }, props), children)));
};
Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;
export default withTheme(Tooltip);
//# sourceMappingURL=Tooltip.js.map